import React, { useLayoutEffect, useState } from "react";
import {
    Grid,
    TextField,
    Paper,
    TableBody } from "../ui";
import Checkbox from '../ui/Checkbox';
import "./Employee.css";
import Table from '../ui/Table';
import TableCell from '../ui/TableCell';
import TableContainer from '../ui/TableContainer';
import TableHead from '../ui/TableHead';
import TableRow from '../ui/TableRow';
import {
  CHECK_EMPLOYEE_IN_JCID,
  GET_EMPLOYEE,
  SET_EMPLOYEE,
  SUCCESS,
  ItemStatus,
  getAuthSession,
  isRoleAllowed,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  ROLE_NA,
  ROLE_VIEW,
  ROLE_CREATE,
  ROLE_UPDATE,
  EMPMGMT,
  GETEMPACCOUNTING,
  getPreUrlAccordingToCart,
  GETSINGLECONFIGS,
  HOTELSALESCONFIG,
  printDebugLog,
  GETVIDEOPATH,
  isFeatureAllowed,
  EMPSALARYMGMT,
  CartDets
} from "../../constants/constant";
import axios from "axios";
import DialogBox from "../global/DialogBox";
import CustomDataGrid from "../global/CustomDataGrid";
import {
    RadioGroup, FormControlLabel,
    FormLabel, Radio
} from "../ui";
import { useSelector } from "react-redux";
import SnpComponent from "../global/SnpComponent";
import { snpAxios } from '../global/api';
import YouTubeVideo from "../global/YouTubeVideo";
import SingleFab from "../global/fab/SingleFab";
import { SCREEN_EMP } from "../../constants/VideoConstant";
import DismissButton from "../global/DismissButton";
import SnpButton from "../global/SnpButton";
import EnterButton from "../global/EnterButton";
import { useNavigate } from "react-router-dom";
export default function Employee({ showDialogBoxWithPaper }) {
    const storeCartType = useSelector(state => state.setCartTypeReducer.cartType);
    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();

    const [isDataLoaded, setDataLoaded] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [isEditProduct, setEditProduct] = useState(false);
    const [checkData, setCheckData] = useState("");
    const [hotelSale, setHotelSales] = useState(false);
    const [checkAccounting, setCheckAccounting] = useState(false);
    const [employeeData, setEmployeeData] = useState([]);
    const [empCount, setEmpCount] = useState(0);
    const [empCreate, setEmpCreate] = useState(false);
    const [myRoles, setMyRoles] = useState(new Map());
	const [myOtherRoles, setMyOtherRoles] = useState(new Map());
    const [myRolesRules, setMyRolesRules] = useState(true);
    const [employeeSingleData, setSingleEmployeeData] = useState({
        empId: "",
        name: "",
        userEmail: "",
        jcId: "",
        activeStatus: 1,
        phone: "",
        createdDate: "",
        passWord: "",
        roles: [{}],
        employeeType: "",
        firstTimeLogin: false,
        haveSalaryComponent: false,
        isChef: false,
    });
    const [videoModel, setVideoModel] = useState({ show: false, path: "" });

    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        isLoader: false,
        iconReq: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
    };
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);

    const INITIAL_DAYBOOK = {
        openingBalance: "",
        todaysBalance: "",
        totalBalance: "",
        totalExpense: "",
        totalDues: "",
        totalLoanAmt: "", todaysExpense: "", todaysDues: "", todaysLoanAmt: "",
        totalCashBalance: "", openingCashBalance: "", todaysCashBalance: "",
        todaysCashExpenses: "", totalCashExpenses: "", totalOnlineBalance: "",
        todaysOnlineBalance: "", openingOnlineBalance: "", totalOnlineExpenses: "",
        todaysOnlineExpenses: "", totalTotalOnlineBalance: "", todaysTotalOnlineBalance: "", openingTotalOnlineBalance: "", totalTotalOnlineExpenses: "",
        todaysTotalOnlineExpenses: "",
    };

    const [dayBook, setDayBook] = useState(INITIAL_DAYBOOK);

    const [formSubmitted, setFormSubmitted] = useState(false);

    const columns = [
        {
            field: 'name', headerName: 'Name', width: 150, renderCell: (params) => (
                <span style={{ fontWeight: 'bold', color: '#151b45' }}>{params.value}</span>
            ),
        },
        { field: 'employeeType', headerName: 'Emp. Type', width: 150 },
        { field: 'userEmail', headerName: 'Email', width: 190 },
        {
            field: 'phone', headerName: 'Phone', width: 150, renderCell: (params) => (
                <span style={{ fontWeight: 'bold', color: '#0f633b' }}>{params.value}</span>
            ),
        },
        { field: 'activeStatusStr', headerName: 'Status', width: 150 },
        { field: 'isChef', headerName: 'Kitchen', width: 100, valueGetter: (params) => params.row.isChef ? 'Chef' : '' },
        {
            field: "edit",
            headerName: "Edit",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onClick={(event) => {
                            if (isRoleAllowed(EMPMGMT, ROLE_UPDATE)) {
                                handleCellClick(event, cellValues);
                            } else {
                                showDialogBoxWithPaper("You Are not allowed to Update Employee.Contact the Owner");
                            }

                        }}
                    >Edit</SnpButton>
                );
            }
        }
    ];


    const columnsAdmin = [
        {
            field: 'name', headerName: 'Name', width: 150, renderCell: (params) => (
                <span style={{ fontWeight: 'bold', color: '#151b45', fontSize: "18px" }}>{params.value}</span>
            ),
        },
        { field: 'employeeType', headerName: 'Emp. Type', width: 150 },
        { field: 'userEmail', headerName: 'Email', width: 200 },
        {
            field: 'phone', headerName: 'Phone', width: 150, renderCell: (params) => (
                <span style={{ color: '#151b45' }}>{params.value}</span>
            ),
        },
        {
            field: 'activeStatusStr', headerName: 'Status', width: 150, valueGetter: (params) => params.row.activeStatusStr, renderCell: (params) => (
                <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
            ),
        },
        { field: 'isChef', headerName: 'Kitchen', width: 100, valueGetter: (params) => params.row.isChef ? 'Chef' : '' },
        {
            field: "view",
            headerName: "",
            width: 120,
            renderCell: (cellValues) => {
                return (
                    //mbgcolor="#899097"
                    <SnpButton variant="contained"
                        mbgcolor="#899097"
                        mpadding="2px 8px"
                        onClick={(event) => {
                            handleViewClick(cellValues.row.empId);
                        }}
                    >View Sales</SnpButton>
                );
            }
        },
        {
            field: "edit",
            headerName: "",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onClick={(event) => {
                            if (isRoleAllowed(EMPMGMT, ROLE_UPDATE)) {
                                handleCellClick(event, cellValues);
                            } else {
                                showDialogBoxWithPaper("You Are not allowed to Update Employee.Contact the Owner");
                            }

                        }}
                    >Edit</SnpButton>
                );
            }
        },
        {
            field: "salary",
            headerName: "",
            width: 140,
            renderCell: (cellValues) => {
                return (
                    isFeatureAllowed(EMPSALARYMGMT) && cellValues.row.haveSalaryComponent &&
                    <SnpButton variant="contained"
                        mbgcolor="#0083c3"
                        mpadding="2px"
                        onClick={() => {
                            if (isRoleAllowed(EMPSALARYMGMT, ROLE_VIEW)) {
                                navigate("/dashboard/employee/salary", { state: { empId: cellValues.row.empId } })
                            } else {
                                showDialogBoxWithPaper("You Are not allowed to Update Employee Salary.Contact your Owner");
                            }

                        }}
                    >Update Salary</SnpButton>
                );
            }
        }
    ];

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'searchJcIdPhone') {
            setCheckData(value);
        } else if (name === 'checkUnCheck') {
            const checked = myRolesRules;
            checkUnCheckRoles(!checked);
        } else if (name === 'haveSalaryComponent') {
            const checked = employeeSingleData.haveSalaryComponent;
            setSingleEmployeeData(prev => ({
                ...prev, haveSalaryComponent: !checked,
            }))
        } else if (name === 'isChef') {
            setSingleEmployeeData(prev => ({
                ...prev, isChef: value === 'true',
            }))
        } else if (name === 'rolechecked') {
			const [feature, bitText] = event.target.id.split("::");
			const bit = Number(bitText);
			setMyOtherRoles(current => {
				const next = new Map(current);
				next.set(OTHER_ADMIN_RIGHTS, false);
				return next;
			});
			setMyRoles(current => {
				const next = new Map(current);
				const currentMask = Number(next.get(feature) ?? ROLE_NA);
				if (bit === ROLE_NA) next.set(feature, ROLE_NA);
				else {
					const toggled = (currentMask & bit) === bit ? currentMask & ~bit : (currentMask & ~ROLE_NA) | bit;
					next.set(feature, toggled === 0 ? ROLE_NA : toggled);
				}
				return next;
			});
		} else if (name === 'otherrolechecked') {
			const role = event.target.id;
			if (role === OTHER_ADMIN_RIGHTS) {
				checkUnCheckRoles(!Boolean(myOtherRoles.get(role)));
				return;
			}
			setMyOtherRoles(current => {
				const next = new Map(current);
				const checked = !Boolean(next.get(role));
				next.set(role, checked);
				if (!checked) next.set(OTHER_ADMIN_RIGHTS, false);
				return next;
			});
        } else if (name === 'phone') {
            const len = value === '' ? 0 : value.length;
            if ((value === '' || /^\d*$/.test(value)) && len <= 10) {
                setSingleEmployeeData({
                    ...employeeSingleData,
                    phone: value,
                });
            }
        } else {
            setSingleEmployeeData({
                ...employeeSingleData,
                [name]: value,
            });
        }
        //console.log("setSingleEmployeeData-> ",employeeSingleData);
    };

    const handleCellClick = (param, event) => {
        //console.log("handleCellClick : ", event.row);
        setSingleEmployeeData({
            ...employeeSingleData,
            empId: event.row.empId,
            name: event.row.name,
            userEmail: event.row.userEmail,
            jcId: event.row.jcId,
            activeStatus: event.row.activeStatus,
            phone: event.row.phone,
            createdDate: event.row.createdDate,
            passWord: "",
            roles: event.row.roles,
            employeeType: event.row.employeeType,
            firstTimeLogin: event.row.firstTimeLogin,
            haveSalaryComponent: event.row.haveSalaryComponent,
            isChef: event.row.isChef ?? false,
        });
		setMyRoles(new Map(Object.entries(event.row.roles ?? {})));
		setMyOtherRoles(new Map(Object.entries(event.row.otherRoles ?? {})));
        setShowDialog(true);
        setEditProduct(true);
    };

    const handleViewClick = (mEmpId) => {
        //console.log("handleViewClick : ", mEmpId);
        setDataLoaded(false);
        let eUrl = storeApiUrl.BACKEND_BASE_URL + GETEMPACCOUNTING
        let filledData = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                empId: mEmpId,
                shopHash: storeActiveShopHash.id,
            }
        };
        snpAxios.post(eUrl, filledData)
            .then(response => {
                //console.log("responses => ", response.data);
                setDataLoaded(true);
                if (response.data.status === SUCCESS) {
                    setDayBook(response.data.jcJson.dayBook);
                    setCheckAccounting(true);
                    setShowDialog(true);
                } else {
                    setSnpComponent({
                        ...snpComponent,
                        snackBarMsg: "No Sales Found for this Employee",
                        snackBarOpen: true,
                    })
                }
            }).catch(error => {
                console.log("error : ", error);
                setDataLoaded(true);
                setSnpComponent({
                    ...snpComponent,
                    snackBarMsg: "No Sales Found for this Employee",
                    snackBarOpen: true,
                })
                //window.location.href = "#/error";
            });
    };

    const callForEmployee = (haveHotel) => {
		setMyRoles(new Map(Object.entries(getAuthSession().roles ?? {})));
		setMyOtherRoles(new Map(Object.entries(getAuthSession().otherRoles ?? {})));
        // console.log('Printing Login Details : ', myRoles);
        getEmployeeDetails();
    };

    const getSingleConfigs = async (mConfigName) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETSINGLECONFIGS}?adminId=${getAuthSession().apiToken}&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
            const response = await axios.get(cUrl);
            printDebugLog(`getSingleConfigs:${mConfigName}`, response);
            if (response.data !== '') {
                if (mConfigName === HOTELSALESCONFIG) {
                    callForEmployee(response.data === 'Yes');
                    setHotelSales(response.data === 'Yes');
                } else {
                    callForEmployee(false);
                }
            }
        } catch (e) {
            console.error(`getSingleConfigs:err${mConfigName}`, e);
            callForEmployee(false);
        }
    };


    const handleEmployeeSubmit = async () => {
        setFormSubmitted(true);
        if (!isValid()) {
            return;
        }
        let catgUrl = storeApiUrl.BACKEND_BASE_URL + SET_EMPLOYEE;
        employeeSingleData.roles = [];
        let jsonObject = {};
        myRoles.forEach((value, key) => {
            jsonObject[key] = value
        });
		const otherRoles = Object.fromEntries(myOtherRoles);
        //console.log(jsonObject);
        setDataLoaded(false);
        let filledData = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                empId: employeeSingleData.empId,
                jcId: employeeSingleData.jcId,
                shopHash: storeActiveShopHash.id,
                phone: employeeSingleData.phone,
                activeStatus: parseInt(employeeSingleData.activeStatus),
                name: employeeSingleData.name,
                userEmail: employeeSingleData.userEmail,
                value: employeeSingleData.passWord,
                employeeType: employeeSingleData.employeeType,
                haveSalaryComponent: employeeSingleData.haveSalaryComponent,
                isChef: employeeSingleData.isChef,
				roles: jsonObject,
				otherRoles
            }
        };
        //console.log("handleEmployeeSubmit filledData => ", filledData);
        setShowDialog(false);
        snpAxios.post(catgUrl, filledData)
            .then(response => {
                setDataLoaded(true);
                printDebugLog("responses => ", response.data);
                if (response.data.status === SUCCESS) {
                    handleDialogClose();
                    getEmployeeDetails();
                }
            }).catch(error => {
                setDataLoaded(true);
                console.log("error : ", error);
                setFormSubmitted(false);
                //window.location.href = "#/error";
            });
    };

    const getEmployeeDetails = async () => {
        let cartUrl = storeApiUrl.BACKEND_BASE_URL + GET_EMPLOYEE;

        let data = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                shopHash: storeActiveShopHash.id,
            }
        };
        //  console.log("getProductDetails  => ",data);
        snpAxios.post(
            cartUrl,
            data
        )
            .then((response) => {
                //console.log("response  => ", response.data.jcJson);
                setDataLoaded(true);
                if (response.data.status === SUCCESS) {
                    setEmployeeData(response.data.jcJson.value_2);
                }
                setEmpCount(response.data.jcJson.empCount);
                setEmpCreate(response.data.jcJson.empCreate);
            }).catch((error) => {
                console.log("errr ", error);
                //window.location.href = "#/error";
            });
    };
    const checkEmployeeInJc = async () => {
        let catgUrl = storeApiUrl.BACKEND_BASE_URL + CHECK_EMPLOYEE_IN_JCID;
        let data = {
            jcJson: {
                value: checkData,
            }
        };
        snpAxios.post(
            catgUrl,
            data
        )
            .then((response) => {

                if (response.data.status === SUCCESS) {
                    //console.log("response checkEmployeeinjc", response.data);
                    setSingleEmployeeData({
                        ...employeeSingleData,
                        empId: "",
                        userEmail: response.data.jcJson.email,
                        jcId: response.data.jcJson.jcId,
                        phone: response.data.jcJson.phone,
                        name: response.data.jcJson.name,
                        passWord: response.data.jcJson.value,
                        activeStatus: 1,
                        roles: [{}],
                    });
                }
            }).catch((error) => {
                console.log("checkEmployeeInJc ", error);
            });
    };
    useLayoutEffect(() => {
        //console.log('Printing Login Details : ', getAuthSession);
        getYoutubeVideo(SCREEN_EMP, 'hi');
        getSingleConfigs(HOTELSALESCONFIG);
    }, [storeCartType, storeActiveShopHash, storeApiUrl]);

    const getYoutubeVideo = (videoName, lang) => {
        let cUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GETVIDEOPATH + `?adminId=${getAuthSession().apiToken}`
            + `&name=${videoName}` + `&lang=${lang}`;
        let data = {};
        axios.get(
            cUrl,
            data
        )
            .then((response) => {
                //printLog("getSingleConfigs<=",response.data);
                if (response.data !== '') {
                    setVideoModel({ ...videoModel, path: response.data });
                } else
                    setVideoModel({ ...videoModel, path: '' });
            }).catch((error) => {
                //printLog("error : ", error);
                //window.location.href = "#/error";
                setVideoModel({ ...videoModel, path: '' });
            });
    };


    const renderDialogContent = () => {
        return (
            <div>
                {
                    employeeSingleData.firstTimeLogin &&
                    <Paper elevation={10}
                        autoHeight
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#d6dfe2",
                            margin: "2px",
                            boxShadow: 1,
                            borderRadius: 5,
                            padding: 2,
                        }} >
                        <Grid item xs={12}>
                            <center>
                                <p>{"First Time Password is: " + employeeSingleData.passWord}</p>
                            </center>
                        </Grid>

                    </Paper>}
                <Paper elevation={10}
                    autoHeight
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#b3ecec",
                        margin: "2px",
                        boxShadow: 1,
                        borderRadius: 5,
                        padding: 2,
                    }} >
                    <Grid container spacing={1}>
                        <Grid item xs={12} >
                            <center>
                                <FormLabel component="legend">Enter Employee Status</FormLabel>
                                <RadioGroup row aria-label="activeStatus" name="activeStatus" value={employeeSingleData.activeStatus.toString()} onChange={handleInputChange} style={{
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <FormControlLabel value={ItemStatus.ACTIVE.toString()} control={<Radio />} label="Active" />
                                    <FormControlLabel value={ItemStatus.INACTIVE.toString()} control={<Radio />} label="InActive" />
                                </RadioGroup>
                            </center>
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <TextField
                                required
                                id="name"
                                label="Enter Employee Name"
                                name="name"
                                variant="filled"
                                size="small"
                                value={employeeSingleData.name}
                                onChange={handleInputChange}
                                fullWidth
                                error={formSubmitted && !employeeSingleData.name}
                                helperText={getErrorMessage('name')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <TextField
                                required
                                id="phone"
                                label="Enter Phone"
                                name="phone"
                                variant="filled"
                                size="small"
                                value={employeeSingleData.phone}
                                onChange={handleInputChange}
                                fullWidth
                                error={formSubmitted && !employeeSingleData.phone}
                                helperText={getErrorMessage('phone')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <TextField
                                required
                                id="userEmail"
                                variant="filled"
                                size="small"
                                label="Enter Email"
                                name="userEmail"
                                value={employeeSingleData.userEmail}
                                onChange={handleInputChange}
                                fullWidth
                                error={formSubmitted && !employeeSingleData.userEmail}
                                helperText={getErrorMessage('userEmail')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <TextField
                                id="employeeType"
                                label="Enter Employee Type"
                                name="employeeType"
                                variant="filled"
                                size="small"
                                value={employeeSingleData.employeeType}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <TextField
                                id="jcId"
                                label="Unique Id"
                                name="jcId"
                                disabled
                                variant="filled"
                                size="small"
                                value={employeeSingleData.jcId}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>
                        {
                            isFeatureAllowed(EMPSALARYMGMT) &&
                            <Grid item xs={12} md={6} sm={6} lg={6}>
                                <FormControlLabel control={<Checkbox
                                    checked={employeeSingleData.haveSalaryComponent}
                                    onChange={handleInputChange}
                                    name="haveSalaryComponent"
                                    fullWidth
                                    id="haveSalaryComponent"
                                />}
                                    label="Add Salary Component" />
                            </Grid>
                        }
                        {storeCartType === CartDets.Resto &&
                            <Grid item xs={12} md={6} sm={6} lg={6}>
                                <FormLabel component="legend">Handle Kitchen Order</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="Handle Kitchen Order"
                                    name="isChef"
                                    value={String(employeeSingleData.isChef)}
                                    onChange={handleInputChange}
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="false" control={<Radio />} label="No" />
                                </RadioGroup>
                            </Grid>
                        }
                    </Grid>
                </Paper>
                <Paper elevation={10}
                    autoHeight
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#a4b9e1",
                        margin: "2px",
                        boxShadow: 1,
                        borderRadius: 5,
                        padding: 2,
                    }} >
                    <Grid container>
                        <Grid item xs={12}>
                            <p style={{
                                whiteSpace: "pre-wrap",
                                overflowWrap: "break-word"
                            }}> Employee Role Management.  <FormControlLabel control={<Checkbox
                                checked={myRolesRules}
                                onChange={handleInputChange}
                                name="checkUnCheck"
                                fullWidth
                                id="checkUnCheck"
                            />}
                                label={myRolesRules ? "Unchecked all roles" : "Checked all roles"} />
                            </p>
                        </Grid>
						{Object.entries(getAuthSession().featureRoleDefinitions ?? {})
							.sort(([left], [right]) => left.localeCompare(right, undefined, { sensitivity: "base" }))
							.map(([feature, definitions]) => (
							<Grid item xs={12} key={feature} sx={{ mb: 1 }}>
								<FormLabel>{feature}</FormLabel>
								<Grid container>
									{Object.entries(definitions)
										.sort(([, left], [, right]) => Number(left) - Number(right))
										.map(([name, bit]) => (
										<Grid item xs={6} sm={3} key={`${feature}-${name}`}>
											<FormControlLabel control={<Checkbox
												checked={Number(bit) === ROLE_NA
													? Number(myRoles.get(feature) ?? ROLE_NA) === ROLE_NA
													: (Number(myRoles.get(feature) ?? ROLE_NA) & Number(bit)) === Number(bit)}
												onChange={handleInputChange} name="rolechecked" id={`${feature}::${bit}`}
											/>} label={name} />
										</Grid>
									))}
								</Grid>
							</Grid>
						))}
						{(getAuthSession().otherRoleDefinitions ?? []).length > 0 && <Grid item xs={12}>
							<FormLabel>Other Roles</FormLabel>
							<Grid container>{[...getAuthSession().otherRoleDefinitions]
								.sort((left, right) => left.localeCompare(right, undefined, { sensitivity: "base" }))
								.map(role => (
								<Grid item xs={12} sm={6} key={role}><FormControlLabel control={<Checkbox
									checked={Boolean(myOtherRoles.get(role))} onChange={handleInputChange}
									name="otherrolechecked" id={role} />} label={role} /></Grid>
							))}</Grid>
						</Grid>}
                    </Grid>
                </Paper>
            </div>
        )
    };


    const getBalance = (type) => {
        let bal = 0;
        if (type === 0)
            bal = dayBook.openingBalance;
        else if (type === 1)
            bal = dayBook.todaysBalance;
        else if (type === 2)
            bal = dayBook.todaysExpense;
        else if (type === 3)
            bal = dayBook.totalBalance;
        else if (type === 4)
            bal = dayBook.totalExpense;
        return bal;
    }

    const renderDialogEmpAccount = () => {
        return (
            <React.Fragment>
                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table" className="rate_card" style={{ backgroundColor: "#dcdede" }}>
                            <TableHead>
                                <TableRow style={{ backgroundColor: "#301800" }}>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center">Cash(₹)</TableCell>
                                    <TableCell align="center">Online(₹)</TableCell>
                                    <TableCell align="center">T.Amt(₹)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.values(dayBook).map((val, index) => {
                                    return (
                                        <TableRow
                                            className="rate_card--row"
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align="center">{val.tye}</TableCell>
                                            <TableCell align="center" >{val.cash}</TableCell>
                                            <TableCell align="center" >{val.online}</TableCell>
                                            <TableCell align="center" >{val.total}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </React.Fragment>
        );
    }

    const renderMainDialogContent = () => {
        return (
            <React.Fragment>
                <div>
                    {
                        checkAccounting ? renderDialogEmpAccount() : renderDialogContent()
                    }
                </div></React.Fragment>
        );
    }

    const renderDialogAction = () => {
        return (
            <React.Fragment>
                {
                    !checkAccounting && <SnpButton variant="contained" onClick={handleEmployeeSubmit}>
                        {isEditProduct ? "Update" : "Submit"}
                    </SnpButton>
                }
                <DismissButton variant="contained" onClick={handleDialogClose}>
                    Dismiss
                </DismissButton>
            </React.Fragment>
        );
    }

    const checkUnCheckRoles = (checked) => {
		const featureRoles = new Map();
		Object.entries(getAuthSession().featureRoleDefinitions ?? {}).forEach(([feature, definitions]) => {
			const mask = checked ? Object.values(definitions).reduce((value, bit) => Number(bit) === ROLE_NA ? value : value | Number(bit), 0) : ROLE_NA;
			featureRoles.set(feature, mask || ROLE_NA);
		});
		setMyRoles(featureRoles);
		setMyOtherRoles(new Map((getAuthSession().otherRoleDefinitions ?? []).map(role => [role, checked])));
        setMyRolesRules(checked);
    }

    const handleDialogClose = () => {
        // console.log("handleDialogClose");

        setSingleEmployeeData({
            empId: "",
            name: "",
            userEmail: "",
            jcId: "",
            activeStatus: 1,
            phone: "",
            createdDate: "",
            passWord: "",
            roles: [],
            employeeType: "",
            firstTimeLogin: false,
            haveSalaryComponent: false,
            isChef: false,
        })
        setDataLoaded(true);
        setCheckAccounting(false);
		setMyRoles(new Map(Object.entries(getAuthSession().roles ?? {})));
		setMyOtherRoles(new Map(Object.entries(getAuthSession().otherRoles ?? {})));
        setShowDialog(false);
        setEditProduct(false);
        setFormSubmitted(false);
        setMyRolesRules(true);
    };

    const getErrorMessage = (field) => {
        if (!formSubmitted) {
            return;
        } else if (!employeeSingleData[field]) {
            return 'Field is required';
        }
    }

    const isValid = () => {
        let isEmployeeDataValid = true;

        if (!employeeSingleData.name || !employeeSingleData.phone || !employeeSingleData.userEmail) {
            isEmployeeDataValid = false;
        }

        return isEmployeeDataValid;
    }
    const renderSnpContent = () => {
        return (
            <React.Fragment>
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ padding: 10 }}>
                            <EnterButton
                                variant="contained"
                                color="primary"
                                sx={{ boxShadow: 10 }}
                                style={{ float: "right" }}
                                onClick={(event) => {
                                    if (isRoleAllowed(EMPMGMT, ROLE_CREATE)) {
                                        if (empCreate)
                                            setShowDialog(true);
                                        else
                                            showDialogBoxWithPaper("You cannot Create Employee more than " + empCount + " .Contact SNP");
                                    } else
                                        showDialogBoxWithPaper("You Are not allowed to Create Employee.Contact the Owner");
                                }}>
                                Add New Employee
                            </EnterButton>
                        </div>

                        <CustomDataGrid
                            getRowId={row => row.empId}
                            rows={employeeData}
                            columns={isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) ? columnsAdmin : columns}
                            loading={!isDataLoaded}
                        />
                    </Grid>
                </Grid>
                < DialogBox
                    showDialog={showDialog}
                    title={checkAccounting ? "Employee Balance Sheet " : isEditProduct ? "Update Employee" : "Add New Employee"}
                    onClose={handleDialogClose}
                    dialogContent={renderMainDialogContent()}
                    dialogActions={renderDialogAction()}
                ></DialogBox>
                {videoModel.show && <YouTubeVideo videoId={videoModel.path} onDismiss={(e) => setVideoModel({ ...videoModel, show: false })} />}
                {videoModel.path && <SingleFab onClick={(e) => setVideoModel({ ...videoModel, show: true })} />}
            </React.Fragment>
        );
    }

    const handleSnackClose = () => {
        setSnpComponent({
            ...snpComponent,
            snackBarOpen: false,
            snackBarMsg: "",
        });
    };
    return (
        <React.Fragment>
            <SnpComponent
                content={renderSnpContent()}
                onSnackClose={handleSnackClose}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </React.Fragment>
    );
}
